// extracted by mini-css-extract-plugin
module.exports = {"flexEnd":"uploadedDocuments_flexEnd__KklEL","container":"uploadedDocuments_container__14qtd","cancelBtn":"uploadedDocuments_cancelBtn__1GBW8"};